<div class="d-flex align-items-center d-block h-100 note-alignment">
    <a [hidden]="hasNotes" (click)="openAddNotesModal()">
        <svg class="icon-16 notes-icon">
            <use href="../App_Themes/CXone/icons/gamification/notes-add.svg#notes-add"></use>
        </svg>
    </a>
    <a [hidden]="!hasNotes" (click)="openAddNotesModal()">
        <svg class="icon-16 notes-icon">
            <use href="../App_Themes/CXone/icons/gamification/notes-with-notification.svg#notes-with-notification">
            </use>
        </svg>
    </a>
</div>